export default __webpack_public_path__ + "static/image-4-88dfee1782b5b61adf4dcd8307cf2560.jpg";